var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs border-t border-gray-300"},[_vm._l((_vm.tabs),function(tab,idx){return _c('button',{key:tab.name,class:[
      'tab-button',
      { active: parseInt(_vm.currentTabIdx) === parseInt(idx) }
    ],on:{"click":function($event){_vm.currentTabIdx = idx}}},[_vm._v(" "+_vm._s(tab.label)+" ")])}),_c('keep-alive',[_c(_vm.tabs[_vm.currentTabIdx].component,{tag:"component",staticClass:"tab"})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }